/* eslint-disable @typescript-eslint/naming-convention -- API defined property names */

import { IsOptional } from 'class-validator';
import { TWResponse } from './response.models';

export class Container {
  id: string;
  parent?: string;
  name: string;
  level: number;
  depth: number;
  level_name: string;
  system_id?: string;
  parent_id?: string | null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  meta_data: any;
  children?: Map<string, Container>;
}

export class ContainerResponse extends TWResponse {
  data: Container;
}

export class ContainerListResponse extends TWResponse {
  data: Container[];
}

export class ContainerTreeResponse extends TWResponse {
  data: Map<string, Container>;
}

export class SubTreeRequestParams {
  @IsOptional()
  depth?: number;
  @IsOptional()
  with_sensors?: boolean;
}
